__turbopack_context__.v({
  "appDetails": "NavigationBurgerMenu-module__pmw_gW__appDetails",
  "auxContact": "NavigationBurgerMenu-module__pmw_gW__auxContact",
  "auxDetails": "NavigationBurgerMenu-module__pmw_gW__auxDetails",
  "headerItems": "NavigationBurgerMenu-module__pmw_gW__headerItems",
  "isActive": "NavigationBurgerMenu-module__pmw_gW__isActive",
  "nav": "NavigationBurgerMenu-module__pmw_gW__nav",
  "navItem": "NavigationBurgerMenu-module__pmw_gW__navItem",
});
